import { Signal, type Component, type Entity2D } from '../../odie';

import type { BlockId, BlockProps } from '../defs/block';
import { CollideEvent, CollideId, Collider } from '../defs/collide';

// types
//-----------------------------------------------------------------------------
export type BlockOptions = {
  id: BlockId;
  props: BlockProps;
};

/*
    common block component
*/
export class BlockComponent implements Component {
  // constants
  //---------------------------------------------------------------------------
  public static readonly NAME = 'block';

  // fields
  //---------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // input
  public blockId!: BlockId;
  public props!: BlockProps;
  // state
  private _width!: number;
  private _height!: number;

  /** Promise for async despawn, used by the DespawnSystem */
  public asyncDespawnPromise?: Promise<void>;

  /**
   * Blocks are spawned with an option number that comes from level data
   * This property should return the current option number for the block,
   * which can be used to save current grid state.
   * Not all blocks have option number, so this can return undefined if so.
   */
  public getGameplayState: () => number | undefined = () => undefined;

  /** Signal emitted when the game starts */
  public signals = {
    onGameStart: new Signal(),
  };

  // properties
  //---------------------------------------------------------------------------
  // width
  public get width(): number {
    return this._width;
  }

  public set width(value: number) {
    this._width = value;
  }

  // height
  public get height(): number {
    return this._height;
  }

  public set height(value: number) {
    this._height = value;
  }

  // height
  public get overlap(): boolean {
    return !!this.props.overlap;
  }

  // impl
  //---------------------------------------------------------------------------
  public init(options: BlockOptions): void {
    this.blockId = options.id;
    this.props = options.props;
    this._width = this.props.width || 1;
    this._height = this.props.height || 1;
    this.asyncDespawnPromise = undefined;
  }

  // api
  //---------------------------------------------------------------------------
  public collide(id: CollideId, collider?: Collider) {
    this.entity.setModified(BlockComponent, {
      collide: { id, collider } as CollideEvent,
    });
  }
}
